import axios from 'axios';

export const getTagsMap = async () => {
  const url = `${process.env.REACT_APP_API_URL}/tags`
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  try {
    const {data} = await axios.get(url,{headers: headers});
    console.log(data)
    return data;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


